export default {
    cma: 'CMA Report',
    soi: 'Property Price Statement',
    pps: 'Property Price Statement',
    rental: ' Rental CMA Report',
};